import { gql } from '@/service/gql'
import type { ResultOf } from 'gql.tada'
import { imageFieldsFrag } from '@/service/fragments/imageFieldsFrag'

/**
 * Minimal Audiobook fragment for browse / recommendation rows. Only
 * pulls the fields the recommendation card needs (cover art, title,
 * authors line, and `playParams` when present so the play affordance
 * can decide whether to render). The detail page query
 * (`audiobookDetailQuery`) ships the full shape.
 */
export const audiobookFieldsFrag = gql(
    `
        fragment audiobookFields on Audiobook @_unmask {
            __typename
            id
            title
            authors {
                name
            }
            images {
                ...imageFields
            }
            playParams {
                id
                containerIds
                selections
            }
        }
    `,
    [imageFieldsFrag]
)

export type AudiobookFields = ResultOf<typeof audiobookFieldsFrag>
